var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-portal', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("sign.SignRequestTable.title")) + " ")])], 1), _c('sign-request-table')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }